package com.shadowings.gero.presentation.navigation

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import com.shadowings.gero.presentation.screen.ExplanationScreen
import com.shadowings.gero.presentation.screen.FeaturePollScreen
import com.shadowings.gero.presentation.screen.IntroScreen
import com.shadowings.gero.presentation.screen.LandingScreen
import com.shadowings.gero.presentation.screen.QuizScreen
import com.shadowings.gero.presentation.screen.AuthScreen
import com.shadowings.gero.presentation.screen.RuleDetailScreen
import com.shadowings.gero.presentation.model.RewardedAdStatus

object Destinations {
    const val INTRO = "intro"
    const val MAIN_LANDING = "main_landing"
    const val EXPLANATION = "explanation"
    const val QUIZ = "quiz"
    const val AUTH = "auth"
    const val RULE_DETAIL = "rule_detail"
    const val FEATURE_POLL = "feature_poll"
}

@Composable
fun AppNavGraph(
    navController: NavHostController,
    tutorialDone: Boolean,
    purchaseFullVersion: () -> Unit,
    restoreFullVersionPurchases: () -> Unit,
    isFullVersionUnlocked: Boolean,
    isPurchaseReady: Boolean,
    watchAdForHearts: () -> Unit = {},
    adStatus: RewardedAdStatus = RewardedAdStatus.LOADING,
) {
    NavHost(
        navController = navController,
        startDestination = if (tutorialDone) Destinations.MAIN_LANDING else Destinations.INTRO
    ) {
        composable(Destinations.INTRO) {
            IntroScreen(navController = navController)
        }
        composable(Destinations.MAIN_LANDING) {
            LandingScreen(
                onExplanationClick = { lessonId ->
                    navController.navigate("${Destinations.EXPLANATION}/$lessonId")
                },
                onQuizClick = { lessonId ->
                    navController.navigate("${Destinations.QUIZ}/$lessonId")
                },
                onRuleClick = { ruleId ->
                    navController.navigate("${Destinations.RULE_DETAIL}/$ruleId")
                },
                onAuthClick = {
                    navController.navigate(Destinations.AUTH)
                },
                onFeaturePollClick = {
                    navController.navigate(Destinations.FEATURE_POLL)
                },
                purchaseFullVersion = purchaseFullVersion,
                isFullVersionUnlocked = isFullVersionUnlocked,
                restoreFullVersionPurchases = restoreFullVersionPurchases,
            )
        }
        composable("${Destinations.EXPLANATION}/{lessonId}") {
            ExplanationScreen(navController = navController)
        }
        composable("${Destinations.QUIZ}/{lessonId}") {
            QuizScreen(
                navController = navController,
                purchaseFullVersion = purchaseFullVersion,
                restoreFullVersionPurchases = restoreFullVersionPurchases,
                isFullVersionUnlocked = isFullVersionUnlocked,
                isPurchaseReady = isPurchaseReady,
                watchAdForHearts = watchAdForHearts,
                adStatus = adStatus,
            )
        }
        composable(Destinations.AUTH) {
            AuthScreen(navController = navController)
        }
        composable("${Destinations.RULE_DETAIL}/{ruleId}") {
            RuleDetailScreen(navController = navController)
        }
        composable(Destinations.FEATURE_POLL) {
            FeaturePollScreen(navController = navController)
        }
    }
}
